module.exports = "/images/vendor/flag-icon-css/flags/1x1/bd.svg?c4a1485f3606f93b55fa19d86ec3219c";